import { Alert } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  font-size: ${({ theme }) => theme.font.size.medium};
  cursor: pointer;
  text-align: center;
`;
